import React from 'react';
import cn from 'classnames';

export const Lightbox = ({ image, close }) => {
  const boxStyles = cn('moodboard-modal -image', { '-open': image });
  const doClose = () => close();
  return (
    <div className={boxStyles}>
      <div className="moodboard-modal_backdrop" onClick={doClose} />
      <div className="moodboard-modal_dialog">
        <button className="moodboard-modal_close" onClick={doClose} />
        {image ? <img src={image.url_original || image.url} /> : null}
      </div>
    </div>
  );
};

export default Lightbox;



// WEBPACK FOOTER //
// ./app/javascript/chat/components/Lightbox.js